<template>
    <div class="nav-wrap">
        <mt-tab-container v-model="selected">
            <mt-tab-container-item id="1">
                <ul>
                    <li class="flex nav-title">
                        <div class="flex1 skyBlue">来源</div>
                        <div class="flex1 waterBlue">名字编号</div>
                        <div class="flex1 skyBlue">时间</div>
                        <div class="flex1 waterBlue">积分</div>
                        <div class="flex1 skyBlue">类型</div>			    		
                    </li>
                    <li
                        class="flex nav-title"
                        v-if="listData.length !== 0"
                        v-for="(item, index) in listData"
                        :key="index"
                    >
                        <div class="flex1">{{ item.nick }}</div>
                        <div class="flex1">{{item.no }}</div>
                        <div class="flex1">时间1</div>
                        <div class="flex1">订单价格</div>
                        <div class="flex1">佣金</div>			    		
                    </li>
                    <div v-if="listData.length === 0" class="empty">
                        <img src="../../../static/img/empty.svg" alt="">
                        <p class='nodata'>暂无更多信息</p>
                    </div>
                </ul>
            </mt-tab-container-item>
        </mt-tab-container>
        <!-- 无数据层 -->
    </div>
</template>

<script>

export default {
  name: 'TableDetail',
  data() {
        return {
            selected:'1',
            listData:[]
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-wrap {
    height: 0.52rem; color: #000;
}
.mint-tab-item {
    color:#000000;
    font-weight:bolder;
}
.is-selected {
    color:#009688 !important;
}
.mint-navbar .mint-tab-item.is-selected {
    border-bottom: 4px solid #009688;
    color: #009688 !important;
    height: 0.07rem;
    margin-bottom: -3px;
    border-radius:3px;
}
hr {
    margin-top: -0.04rem
}
.nav-title {
    height: 0.32rem;
    line-height: 0.32rem;
}
ul {
    padding-left: 0px;
    text-align: center;
    margin-top: 0;
}
.empty {
    margin-top: 1.06rem;
}
.nodata {
    color: #7F7F7F;
    margin-top: .22rem;
    font-size: 14pt;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/userScoreElement/TableDetail.vue